/**
 * Plugin / strumenti aggiuntivi di Hostland — sezione "Migliora il tuo Hostland".
 * Banner uniformi nella dashboard host + pagina interna dedicata /plugin/{slug}.
 *
 * IMMAGINE SOSTITUIBILE: ogni plugin ha un campo `image`. Se valorizzato con un URL,
 * il banner usa quell'immagine come sfondo (con overlay per il testo); se vuoto ("")
 * usa il gradiente `from`→`to`. Per sostituire la grafica basta incollare l'URL qui.
 */

export const HOSTLAND_PLUGINS = [
  {
    slug: "locazione-turistica",
    icon: "FileText",
    from: "#2563EB",
    to: "#1E3A8A",
    image: "",
    badge: "",
    banner: "Contratti di locazione turistica pronti in un minuto",
    title: "Locazione Turistica",
    subtitle: "Contratti digitali a norma, firma e invio automatico",
    price: "Incluso nel piano",
    seo: {
      title: "Locazione Turistica — Contratti digitali | Hostland",
      description: "Genera contratti di locazione turistica a norma, falli firmare e inviali agli ospiti in automatico dalla dashboard Hostland.",
    },
    hero: {
      title: "Contratti di locazione turistica, senza stress",
      subtitle: "Modelli a norma, compilazione guidata, firma e invio automatico all'ospite. Tutto dentro Hostland.",
    },
    what: "La Locazione Turistica di Hostland trasforma la parte burocratica in un gesto da un minuto: scegli il modello, i dati della prenotazione vengono precompilati, l'ospite riceve il contratto da firmare e tu hai tutto archiviato e tracciato. Niente più PDF persi tra le email.",
    benefits: [
      { title: "Modelli sempre aggiornati", desc: "Contratti conformi alla normativa sulle locazioni turistiche, pronti all'uso." },
      { title: "Compilazione automatica", desc: "Nome, date e importi presi dalla prenotazione: zero copia-incolla." },
      { title: "Firma e archivio", desc: "L'ospite firma dal telefono, tu ritrovi ogni contratto nella dashboard." },
    ],
    pricing: { label: "Incluso nel piano", detail: "Nessun costo aggiuntivo: la generazione contratti è parte di Hostland.", cta: "Attiva ora", ctaLink: "/dashboard" },
    faqs: [
      { q: "I contratti sono a norma?", a: "Sì, i modelli seguono la normativa italiana sulle locazioni turistiche e vengono mantenuti aggiornati." },
      { q: "L'ospite deve stampare qualcosa?", a: "No: riceve il contratto via link, lo firma dal telefono e resta tutto digitale e archiviato." },
    ],
  },
  {
    slug: "self-checkin",
    icon: "ScanLine",
    beta: true,
    from: "#0F172A",
    to: "#334155",
    image: "",
    badge: "Più richiesto",
    banner: "Self check-in e identificazione ospiti, in autonomia totale",
    title: "Self Check-in",
    subtitle: "Identificazione ospiti, documenti e spioncino digitale",
    price: "€19,90 / anno",
    seo: {
      title: "Self Check-in — Identificazione ospiti digitale | Hostland",
      description: "Gestisci check-in self-service, raccolta documenti e identificazione ospiti in autonomia con Hostland. Solo €19,90/anno.",
    },
    hero: {
      title: "Il check-in che si fa da solo",
      subtitle: "L'ospite si identifica, carica i documenti e accede in autonomia. Tu ricevi tutto, senza incontri all'arrivo.",
    },
    what: "Il Self Check-in digitalizza l'intero arrivo: l'ospite compila i dati, carica il documento, tu li ritrovi pronti per gli adempimenti. Con lo spioncino e l'accesso guidato, i tuoi ospiti entrano in autonomia a qualsiasi ora, senza che tu debba essere sul posto.",
    benefits: [
      { title: "Identificazione ospiti", desc: "Raccogli dati e documenti in modo ordinato, pronti per gli adempimenti." },
      { title: "Accesso in autonomia", desc: "Istruzioni guidate e spioncino digitale: l'ospite entra anche se tu non ci sei." },
      { title: "Zero attese all'arrivo", desc: "Niente consegna chiavi di persona: check-in fluido a qualsiasi orario." },
    ],
    pricing: { label: "€19,90 / anno", detail: "Un intero anno di self check-in e identificazione per la tua struttura.", cta: "Attiva Self Check-in", ctaLink: "/dashboard" },
    faqs: [
      { q: "Quanto costa il Self Check-in?", a: "19,90€ all'anno per struttura, senza costi nascosti." },
      { q: "È adatto agli affitti brevi?", a: "Sì: è pensato per case vacanza, B&B e affitti brevi che vogliono automatizzare arrivo e identificazione." },
    ],
  },
  {
    slug: "eventi",
    icon: "CalendarDays",
    from: "#D946EF",
    to: "#7C3AED",
    image: "",
    badge: "",
    banner: "Mostra gli eventi della città ai tuoi ospiti, in automatico",
    title: "Hostland Eventi",
    subtitle: "Eventi locali nel Welcome Book, sempre aggiornati",
    price: "Incluso gratis",
    seo: {
      title: "Hostland Eventi — Eventi locali per i tuoi ospiti | Hostland",
      description: "Arricchisci il Welcome Book con gli eventi della città: concerti, fiere, sagre. Rete nazionale + feed automatico, sempre aggiornati.",
    },
    hero: {
      title: "Gli eventi della città, direttamente ai tuoi ospiti",
      subtitle: "Concerti, fiere, sagre e grandi eventi vicino alla tua struttura, aggiornati in automatico nel Welcome Book.",
    },
    what: "Hostland Eventi porta nel Welcome Book gli appuntamenti che rendono memorabile un soggiorno. Attingi alla rete pubblica di host, al feed nazionale e ai tuoi eventi personali: i viaggiatori trovano cosa fare senza cercare altrove, e tu diventi il loro punto di riferimento sul territorio.",
    benefits: [
      { title: "Sempre aggiornati", desc: "Feed automatico dei grandi eventi + rete host: il calendario si riempie da solo." },
      { title: "Aggiungi i tuoi", desc: "Carichi un PDF o un evento manuale e lo mostri subito agli ospiti." },
      { title: "Esperienza migliore", desc: "Ospiti più soddisfatti, recensioni migliori, ritorni più probabili." },
    ],
    pricing: { label: "Incluso gratis", detail: "La sezione Eventi è parte del Welcome Book, senza costi aggiuntivi.", cta: "Gestisci gli eventi", ctaLink: "/dashboard" },
    faqs: [
      { q: "Da dove arrivano gli eventi?", a: "Da un feed nazionale di grandi eventi, dalla rete pubblica di altri host e dagli eventi che aggiungi tu." },
      { q: "Compaiono tutti automaticamente?", a: "Gli eventi della rete e del feed li importi con un clic; i tuoi eventi personali sono subito visibili agli ospiti." },
    ],
  },
  {
    slug: "parkhost",
    icon: "Car",
    from: "#2563EB",
    to: "#0EA5E9",
    image: "",
    badge: "Attivo",
    banner: "Monetizza posti auto, box e garage inutilizzati",
    title: "ParkHost",
    subtitle: "Parcheggi, box e posti auto con lo stesso account",
    price: "Prima registrazione gratis · poi €4,99/anno",
    seo: {
      title: "ParkHost — Affitta posti auto e garage | Hostland",
      description: "Hai un posto auto, box o garage inutilizzato? Con ParkHost crei la pagina, ricevi contatti diretti e guadagni senza commissioni.",
    },
    hero: {
      title: "Il tuo posto auto che lavora per te",
      subtitle: "Crei la pagina del parcheggio, ricevi contatti diretti dagli automobilisti e guadagni senza commissioni.",
    },
    what: "ParkHost è il modulo per chi ha un posto auto, box, garage o giardino inutilizzato. Pubblichi la pagina del parcheggio con foto e posizione, gli automobilisti ti contattano direttamente via email o WhatsApp e tu incassi senza intermediari. Tutto gestito dallo stesso account Hostland.",
    benefits: [
      { title: "Contatti diretti", desc: "Gli automobilisti ti scrivono su email/WhatsApp: nessuna commissione sul guadagno." },
      { title: "Stesso account", desc: "Gestisci parcheggi e strutture dalla stessa dashboard Hostland." },
      { title: "Visibilità sul portale", desc: "La pagina entra nella ricerca Hostland e porta richieste qualificate." },
    ],
    pricing: { label: "Prima registrazione gratis", detail: "La prima pagina parcheggio è gratis, poi €4,99/anno per mantenerla online.", cta: "Apri la Dashboard ParkHost", ctaLink: "/dashboard" },
    faqs: [
      { q: "Quanto costa ParkHost?", a: "La prima registrazione è gratuita, poi 4,99€ all'anno per pagina parcheggio." },
      { q: "Come incasso?", a: "Gli automobilisti ti contattano direttamente: concordi tu modalità e pagamento, senza commissioni Hostland." },
    ],
  },
  {
    slug: "hostlab",
    icon: "GraduationCap",
    from: "#7C3AED",
    to: "#4F46E5",
    image: "",
    badge: "",
    banner: "Formazione e webinar per host: diventa un host migliore",
    title: "HostLab",
    subtitle: "Il nuovo modo di fare formazione di Vita da Host",
    price: "A partire da 10€",
    seo: {
      title: "HostLab — Corsi e formazione per host | Hostland",
      description: "Entra su HostLab di Vita da Host: corsi LIVE, webinar e guide per gestire al meglio la tua struttura. A partire da 10€.",
    },
    hero: {
      title: "Impara a gestire la tua struttura come un pro",
      subtitle: "Corsi LIVE, webinar e guide pratiche di Vita da Host. Dalla burocrazia al marketing, impari da chi fa l'host ogni giorno.",
    },
    what: "HostLab è lo spazio formativo di Vita da Host: corsi LIVE, webinar e guide pratiche per padroneggiare la gestione della tua struttura, aumentare le prenotazioni dirette e lavorare meglio con meno fatica. I percorsi partono da 10€ e coprono tutto, dalla burocrazia al marketing.",
    benefits: [
      { title: "Corsi LIVE", desc: "Sessioni pratiche su check-in, prezzi, disintermediazione e normativa." },
      { title: "Guide e trucchi", desc: "Contenuti concreti per sfruttare ogni funzione al massimo." },
      { title: "Community di host", desc: "Confronto con oltre 70.000 host e property manager italiani." },
    ],
    pricing: { label: "A partire da 10€", detail: "Corsi e formazione LIVE di Vita da Host per host e property manager.", cta: "Scopri HostLab", ctaLink: "https://www.vitadahost.it/hostlab" },
    faqs: [
      { q: "Quanto costa HostLab?", a: "I percorsi partono da 10€: trovi corsi LIVE, webinar e contenuti su misura per host e property manager." },
      { q: "Serve esperienza?", a: "No: i contenuti vanno dalle basi fino ai temi avanzati, adatti sia ai nuovi host sia ai professionisti." },
    ],
  },
];

export const getPlugin = (slug) => HOSTLAND_PLUGINS.find((p) => p.slug === slug);
